var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.meta.hasSidebox)?_c('div',{staticClass:"sidebox"},[_c('help-box'),_c('quote')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }